export default __webpack_public_path__ + "static/video2-7c6b99eb22d4d381e646c897e6f1f01c.jpg";